module.exports = {
      id: "gzsports-usage",
      viewBox: "0 0 17.95 23.898",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#gzsports",
      toString: function () {
        return this.url;
      }
    }